export default "__VITE_ASSET__DFE0Nr4b__"